import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import {AnalyticsService} from "../analytics.service";

@Component({
  selector: 'app-app-download-banner',
  templateUrl: './app-download-banner.component.html',
  styleUrls: ['./app-download-banner.component.css']
})
export class AppDownloadBannerComponent implements OnInit {

  constructor(private analyticsService: AnalyticsService) { }

  ngOnInit(): void {
  }

  appDownload() {
    this.analyticsService.logEvent('app_download_bottom_banner')
    window.open(environment.appDownloadBottomBannerDynamicLink, "appDownloadBottomBannerDynamicLink")
  }
}
